// Form11.jsx
import React, { useEffect, useState } from 'react';
import ABTextEdu from '../../Common/ABTextEdu';
import ABMonthYear from '../../Common/ABMonthYear';
import RadioButtonGroup from '../../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup';
import EMPDate from '../../EmploymentForm/empDate';
import QualificationDropdown from '../../DiyDigilockerNonIBridge/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import TextField from './textField';
import { SaveOnboardingDetails } from '../../../Actions/onboardingDetailsAction';
import Loader from '../../Common/loader';
import { toast } from 'react-toastify';
import Checkbox from '../../../UI_Design/FormComponents/CheckboxAndLabel/Checkbox';

const Form11 = ({ tab, tabId, tabArr, referenceNo, showProfilePreview, caseCheckId, fields, index, allDisabled, otherInstituteObj }) => {
  
  let url = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(url, 'url');
  const [EpfData,setEpfData]=useState([]);
  const [val,setVal]=useState({});
  const [isInternationalWorker, setIsInternationalWorker] = useState(null);
  const [earlierEpfMember, setEarlierEpfMember] = useState();
  const [earlierEpsMember, setEarlierEpsMember] = useState();
  const [previousEpfMember, setPreviousEpfMember] = useState();
  const [maritalStatus, setMaritalStatus] = useState();
  const [prevTab, setPrevTab] = useState('');
  const [nextTab, setNextTab] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const storeOnboardingData = useSelector((state) => state.onboardingDetail);
  const {onboardingDetailData, loading, error}=storeOnboardingData;
  console.log(tab, 'formTab')

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    window.scrollTo(0,0)
  }, []);

  // let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  // let clientId;

  // if(user && user?.bridge_client_id){
  //   clientId = user?.bridge_client_id;  
  // }

  useEffect(()=>{
      if (  typeof onboardingDetailData !== "undefined" && onboardingDetailData !== null ) {
        console.log(tab?.field_details);
        let newData = {...tab};
        setIsLoading(true);
        let showPfFields, showPfQues = '';

        let unExemptedArr = [
          "Form_11_EPF_unexempted_company_name",
          "Form_11_EPF_unexempted_company_address",
          "Form_11_EPF_unexempted_uan",
          "Form_11_EPF_unexempted_doj",
          "Form_11_EPF_unexempted_doe",
          "Form_11_EPF_unexempted_ncp",
          "Form_11_EPF_unexempted_pf_account_no",
          "Form_11_EPF_unexempted_ppo_number",
          "Form_11_EPF_unexempted_scheme_certificate)number",
          
        ];
        let exemptedArr = [
          "Form_11_EPF_exempted_trust_name",
          "Form_11_EPF_exempted_trust_address",
          "Form_11_EPF_exempted_trust_eps_acc_no",
          "Form_11_EPF_exempted_trust_scheme_certificate_no",
          "Form_11_EPF_exempted_trust_uan",
          "Form_11_EPF_exempted_trust_ncp_days",
          "Form_11_EPF_exempted_trust_doj",
          "Form_11_EPF_exempted_trust_dol",
        ];
        // let tabName = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
        // console.log(onboardingDetailData?.data?.tabDetails[tabName.split('_').join(' ')]?.field_details);
        // setEpfData(onboardingDetailData?.data?.tabDetails[tabName.split('_').join(' ')]?.field_details);
        // Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //   // if(item?.id != '200' && item?.id != '201' && item?.id != '1529' && item?.id != '1530' ){
        //   //   item.is_visible = '0';
        //   // }
        //   // debugger
        //   if((item?.slug == 'earlier_member_epf_scheme' || item?.slug == 'earlier_member_ep_scheme')){
        //     if(item?.value == 'YES' || item?.value == 'Yes' ||){
        //       showPfQues = item?.value;
        //     }else{

        //     } 
        //   }

        //   if(item.slug = 'Form_11_EPF_exempt_pf_trust'){
        //      if(showPfQues == 'YES' || showPfQues == 'Yes'){
        //       item.is_visible = '1';
        //         Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //           if(exemptedArr.includes(item?.slug)){
        //             item.is_visible = '1'
        //           }else if(unExemptedArr.includes(item?.slug)){
        //             item.is_visible = '0';
        //           }
        //         })
        //       }else{
        //         Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //           if(unExemptedArr.includes(item?.slug) ){
        //             item.is_visible = '1';
        //           }else if(exemptedArr.includes(item?.slug)){
        //             item.is_visible = '0';
        //           }
        //         })
        //      } 
        //       }
              
        //   //    }else{
        //   //     item.is_visible = '0';
        //   // }

        //   if(item.slug = 'Form_11_EPF_exempt_pf_trust'){
        //     // showPfFields = item?.value;
        //     // handleRadioButtonChange('','','',item?.value , item?.slug , `${item?.slug}-${item?.id}`)
        //       // Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //       //   if(item?.id == '1541'){
        //       //     setMaritalStatus(item?.value);
        //       // }
        //     // })
        //   }

        // })

        let epf , eps = false;

      Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {

        if(item?.slug == 'earlier_member_epf_scheme'){
          Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
            if(item?.slug == 'Form_11_EPF_exempt_pf_trust'){
              item.is_visible = item?.value == 'Yes' || item?.value == 'YES' || earlierEpsMember ? '1' : '0';
            }
            if(item?.slug != 'earlier_member_epf_scheme' && item?.slug != 'earlier_member_ep_scheme' && (item?.value == 'No' || item?.value == 'NO') && !earlierEpsMember){
              item.is_visible = '0';
            }
            
          })
          if(item?.value == 'Yes' || item?.value == 'YES'){
            setEarlierEpfMember(true);
            epf = true;
          }else{
            setEarlierEpfMember(false);
            epf = false;
          } 
        }
        // previous employment ques2
        if(item?.slug == 'earlier_member_ep_scheme'){
          Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
            if(item?.slug == 'Form_11_EPF_exempt_pf_trust'){
              item.is_visible = item?.value == 'Yes' || item?.value == 'YES' || earlierEpfMember ? '1' : '0';
            }
            if(item?.slug != 'earlier_member_epf_scheme' && item?.slug != 'earlier_member_ep_scheme' && (item?.value == 'No' || item?.value == 'NO') && !earlierEpfMember){
              item.is_visible = '0';
            }
            })
          if(item?.value == 'Yes' || item?.value == 'YES'){
            setEarlierEpsMember(true) 
            eps = true;
          }else{
            setEarlierEpsMember(false) ;
            eps = false;
          }
        }
        // previous employment fields
        if(item?.slug == "Form_11_EPF_exempt_pf_trust"){

          earlierEpfMember || earlierEpsMember || epf || eps ? item.is_visible = '1' : item.is_visible = '0' ;

          if((item?.value == 'Yes' || item?.value == 'YES' || item?.value == 'Exempted PF Trust' ) && (eps || epf)){
            Object.values(newData?.['Previous Employment Details']?.field_details).map((items) => {
              // if(item?.slug == 'earlier_member_epf_scheme'){
              //   if(item?.value == 'Yes' || item?.value == 'YES'){

              //   }else{
              //     setEarlierEpsMember(false) ;
              //   }
              // }

              if(exemptedArr.includes(items?.slug)){
                items.is_visible = '1';
                // optional to make the fields as mandatory
                // item.is_mandatory = '1'
              }else if(unExemptedArr.includes(items?.slug)){
                items.is_visible = '0';
                // item.value = ''
              }
            })
          }else if((item?.value == 'NO' || item?.value == 'No' || item?.value == 'EPF Registered' ) && (eps || epf)){
            // item.is_visible = '0';
            Object.values(newData?.['Previous Employment Details']?.field_details).map((items) => {
              if(unExemptedArr.includes(items?.slug) ){
                items.is_visible = '1';
              }else if(exemptedArr.includes(items?.slug)){
                items.is_visible = '0';
              }
            })
          }
          // else{
          //   Object.values(newData?.['Previous Employment Details']?.field_details).map((items) => {
          //     if(unExemptedArr.includes(items?.slug) ){
          //       items.is_visible = '0';
          //     }else if(exemptedArr.includes(items?.slug)){
          //       items.is_visible = '0';
          //     }
          //   })
            // item.is_visible = '0';
            // Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
            //   if(unExemptedArr.includes(item?.slug) ){
            //     item.is_visible = '1';
            //   }else if(exemptedArr.includes(item?.slug)){
            //     item.is_visible = '0';
            //   }
            // })
          // }
        }

      })


        let maritalVal = ''
        Object.values(newData?.['Form 11']?.field_details).map((item) => {
          if(item?.slug == "marital_status"){
              setMaritalStatus(item?.value);
              maritalVal = item?.value;
          }
          if(item?.slug == "Form_11_marriage_date" && maritalVal == 'Married'){
            item.is_visible = '1';
          }
          if(item?.slug == "dependent_spouse_name" && maritalVal == 'Married'){
            item.is_visible = '1';
          }
        })
        let intVal = ''
        Object.values(newData?.['Passport Details']?.field_details).map((item) => {
          if(item?.slug == "international_worker"){
              // setMaritalStatus(item?.value);
              intVal = item?.value;
          }else if(intVal == 'YES' || intVal == 'Yes'){
            item.is_visible = '1';  
          }
        })

        console.log(newData, 'new')
        setEpfData(newData);

        // Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //   if(item.slug = 'Form_11_EPF_exempt_pf_trust'){
        //     showPfFields = item?.value;
        //     handleRadioButtonChange('','','',item?.value , item?.slug , `${item?.slug}-${item?.id}`)
        //       // Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        //       //   if(item?.id == '1541'){
        //       //     setMaritalStatus(item?.value);
        //       // }
        //     // })
        //   }

        // })

        newData && Object.entries(newData).map(([key,item], idx) => {
          item?.field_details.map((field) => {
            setVal((prev)=>({
              ...prev,
              [field?.slug] : field?.value
            }))
          })
        })

        let currTabIdx = ''
        Object.entries(tabArr).map(([item, id], index) => {
          if(id == tabId){
            currTabIdx = index
          }
        })
        let prevTab, nextTab;
        let allTabs = Object.keys(tabArr);
        if(currTabIdx > 0){
          // prevTab = allTabs[currTabIdx-1];
          setPrevTab(allTabs[currTabIdx-1]);
        }
        if(currTabIdx <= allTabs.length-1){
          // nextTab = allTabs[currTabIdx+1];
          // setNextTab(nextTab)
          setNextTab(allTabs[currTabIdx+1]);
        }
        console.log(nextTab);
        // navigate(`/onbordingDetailsInstaform/${prevTab.replaceAll(' ', '_',)}`)
        setIsLoading(false);
      }
  },[onboardingDetailData, storeOnboardingData, url]);

  // useEffect(() => {

  // },[maritalStatus])


 
  const saveDateHandler = (checkDetailsIndex, fieldName, date, name, err_id) => {
    console.log(`Date saved: ${date}`);
    setVal((prev)=>({
      ...prev,
      [name] : date.split('/').join('-')
    }))
    let errorTag = document.getElementById(err_id);
    errorTag.innerHTML = ''
    // Implement your date saving logic here
  };

  const handleDropdownChange = (value) => {
    // console.log(`Selected value: ${event.target.value}`);
    // Implement your dropdown change logic here
    let newData = {...EpfData}
    setVal((prev)=>({
      ...prev,
      [value[0].name] : value[0].value
    }))
    if(value[0].name == 'marital_status'){
      setMaritalStatus(value[0].value);
      // if(value[0].value == 'Married'){
        Object.values(newData?.['Form 11']?.field_details).map((item) => {
          if(item?.slug == 'marital_status'){
            item.value = value[0].value;
          }
          if(item?.slug == 'dependent_spouse_name'){
            if(value[0].value == 'Married'){
              item.is_visible = '1';
              item.is_mandatory = '1';
            }else{
              item.is_visible = '0';
              item.is_mandatory = '0';
              item.value = '';
              setVal((prev)=>({
                ...prev,
                [item?.slug] : ''
              }))
            }
          }
          if(item?.slug == 'Form_11_marriage_date'){
            if(value[0].value == 'Married'){
              item.is_visible = '1';
              // item.is_mandatory = '1';
            }else{
              item.is_visible = '0';
              item.is_mandatory = '0';
              item.value = '';
              setVal((prev)=>({
                ...prev,
                [item?.slug] : ''
              }))
            }
          }
        })
      // }
    }
    setEpfData(newData);
    let errorTag = document.getElementById(value?.[0]?.err_id);
    errorTag.innerHTML = ''
  };

  const handleRadioButtonChange = (index, id, selectedOption, option, name, err_id) => {
    let newData = {...EpfData}
    setVal((prev)=>({
      ...prev,
      [name] : option
    }))
    let errorTag = document.getElementById(err_id);
    errorTag.innerHTML = ''

    let unExemptedArr = [
      "Form_11_EPF_unexempted_company_name",
      "Form_11_EPF_unexempted_company_address",
      "Form_11_EPF_unexempted_uan",
      "Form_11_EPF_unexempted_doj",
      "Form_11_EPF_unexempted_doe",
      "Form_11_EPF_unexempted_ncp",
      "Form_11_EPF_unexempted_pf_account_no",
      "Form_11_EPF_unexempted_ppo_number",
      "Form_11_EPF_unexempted_scheme_certificate)number",
      
    ];
    let exemptedArr = [
      "Form_11_EPF_exempted_trust_name",
      "Form_11_EPF_exempted_trust_address",
      "Form_11_EPF_exempted_trust_eps_acc_no",
      "Form_11_EPF_exempted_trust_scheme_certificate_no",
      "Form_11_EPF_exempted_trust_uan",
      "Form_11_EPF_exempted_trust_ncp_days",
      "Form_11_EPF_exempted_trust_doj",
      "Form_11_EPF_exempted_trust_dol",
    ];

    // previous employment ques1
    if(name == 'earlier_member_epf_scheme'){
      Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        if(item?.slug == 'Form_11_EPF_exempt_pf_trust'){
          item.is_visible = option == 'Yes' || option == 'YES' || earlierEpsMember ? '1' : '0';
        }
        if(item?.slug != 'earlier_member_epf_scheme' && item?.slug != 'earlier_member_ep_scheme' && (option == 'No' || option == 'NO') && !earlierEpsMember){
          item.is_visible = '0';
        }
        
      })
      if(option == 'Yes' || option == 'YES'){
        setEarlierEpfMember(true);
      }else{
        setEarlierEpfMember(false);
      } 
    }
    // previous employment ques2
    if(name == 'earlier_member_ep_scheme'){
      Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
        if(item?.slug == 'Form_11_EPF_exempt_pf_trust'){
          item.is_visible = option == 'Yes' || option == 'YES' || earlierEpfMember ? '1' : '0';
        }
        if(item?.slug != 'earlier_member_epf_scheme' && item?.slug != 'earlier_member_ep_scheme' && (option == 'No' || option == 'NO') && !earlierEpfMember){
          item.is_visible = '0';
        }
        })
      if(option == 'Yes' || option == 'YES'){
        setEarlierEpsMember(true) 
      }else{
        setEarlierEpsMember(false) ;
      }
    }
    // previous employment fields
    if(name == "Form_11_EPF_exempt_pf_trust"){
      if(option == 'Yes' || option == 'YES' || option == 'Exempted PF Trust'){
        Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
          if(exemptedArr.includes(item?.slug)){
            item.is_visible = '1';
            // optional to make the fields as mandatory
            // item.is_mandatory = '1'
          }else if(unExemptedArr.includes(item?.slug)){
            item.is_visible = '0';
            item.value = ''
            setVal((prev)=>({
              ...prev,
              [item?.slug] : ''
            }))
          }
        })
      }else{
        Object.values(newData?.['Previous Employment Details']?.field_details).map((item) => {
          if(unExemptedArr.includes(item?.slug) ){
            item.is_visible = '1';
          }else if(exemptedArr.includes(item?.slug)){
            item.is_visible = '0';
            item.value = ''
            setVal((prev)=>({
              ...prev,
              [item?.slug] : ''
            }))
          }
        })
      }
    }
    // if(id == '1541'){
    //   setMaritalStatus(option);
    //   if(option == 'Married'){
    //     Object.values(newData?.['FORM 11']?.field_details).map((item) => {
    //       if(item?.id == '1541'){
    //         item.value = option;
    //       }
    //       if(item?.id == '1540'){
    //         if(option == 'Married'){
    //           item.is_visible = '1';
    //           item.is_mandatory = '1';
    //         }else{
    //           item.is_visible = '0';
    //           item.is_mandatory = '0';
    //         }
    //       }
    //     })
    //   }
    // }
    // international worker ques
    if(name == 'international_worker'){
      let intWorkerArr = ["country_of_origin", "pf_passport_number", "validity_of_passport_from", "validity_of_passport_to"];
      Object.values(newData?.['Passport Details']?.field_details).map((item) => {
        if(intWorkerArr.includes(item?.slug)){
          item.is_visible = option == 'Yes' || option == 'YES' ? '1' : '0';
          item.is_mandatory = option == 'Yes' || option == 'YES' ? '1' : '0';
        }
      })
      if(option == 'Yes' || option == 'YES'){
        setIsInternationalWorker(true);
      }else{
        setIsInternationalWorker(false);
      }
    }
    setEpfData(newData);
    // setIsInternationalWorker(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangePFS1952 = (index) => {
    // setIsInternationalWorker(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangeEPS1995 = (index) => {
    // setIsInternationalWorker(index === 0); // Assuming "Yes" is the first option
  };

  const handleRadioButtonChangeEPFSorEPS = (index) => {
    // setIsInternationalWorker(index === 0); // Assuming "Yes" is the first option
  };

  const textHandler = (value) => {
    setVal((prev)=>({
      ...prev,
      [value[0].name] : value[0].value
    }))
    let errorTag = document.getElementById(value?.[0]?.err_id);
    errorTag.innerHTML = ''
  }

  const handleBack = (e) => {
    e.preventDefault();
    // previous tab
    // navigate(-1);
    // let prevTabIdx = ''
    // Object.entries(tabArr).map(([item, id], index) => {
    //   if(id == tabId){
    //     prevTabIdx = index
    //   }
    // })
    // let prevTab
    // if(prevTabIdx > 0)
    // prevTab = Object.keys(tabArr)[prevTabIdx-1];
    // console.log(prevTab);
    // navigate(`/onbordingDetailsInstaform/${prevTab.replaceAll(' ', '_',)}`)
    navigate(`/case-initiation/check-detail/${referenceNo}/11/${prevTab.replaceAll(" ", "_")}`)
    // navigate(prevTab);
  }

  const saveHandler = (e) => {
    e.preventDefault();
    let err = formValidation();
    // let err = false;
    console.log(err);
    if(err){
      console.log('error') 
      toast.dismiss();
      let msg = "Please fill all required fields"
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsLoading(false)
    }else{

      setIsLoading(true);
      // api call
     let obj = {
        "tab_id" : tabId,
        // "customfields_data" : {
        //     "Form_11_doj" : "01/07/2024",
        //     "marital_status" : "Dissolved",
        //     "kyc_bank_name" : "test bank",
            // "nominee_name" : {
            //     "0" : "rerwrerew"
            // }
        // }
        "customfields_data" : {...val}
    }

    let unExemptedArr = [
      "Form_11_EPF_unexempted_company_name",
      "Form_11_EPF_unexempted_company_address",
      "Form_11_EPF_unexempted_uan",
      "Form_11_EPF_unexempted_doj",
      "Form_11_EPF_unexempted_doe",
      "Form_11_EPF_unexempted_ncp",
      "Form_11_EPF_unexempted_pf_account_no",
      "Form_11_EPF_unexempted_ppo_number",
      "Form_11_EPF_unexempted_scheme_certificate)number",
    ];
    let exemptedArr = [
      "Form_11_EPF_exempted_trust_name",
      "Form_11_EPF_exempted_trust_address",
      "Form_11_EPF_exempted_trust_eps_acc_no",
      "Form_11_EPF_exempted_trust_scheme_certificate_no",
      "Form_11_EPF_exempted_trust_uan",
      "Form_11_EPF_exempted_trust_ncp_days",
      "Form_11_EPF_exempted_trust_doj",
      "Form_11_EPF_exempted_trust_dol",
    ];

    let allRes = obj?.['customfields_data']
    Object.entries(allRes).map(([key,value], idx) => {
      if(key == 'Form_11_EPF_exempt_pf_trust'){
        if((val['earlier_member_epf_scheme'] == 'No' || val['earlier_member_epf_scheme'] == 'NO') && (val['earlier_member_ep_scheme'] == 'No' || val['earlier_member_ep_scheme'] == 'NO')){
          allRes['Form_11_EPF_exempt_pf_trust'] = '';
          unExemptedArr.map((item) => {
            allRes[item] = ''
          })
          exemptedArr.map((item) => {
            allRes[item] = ''
          })
        } 
      }
    })

      dispatch(SaveOnboardingDetails(obj,saveCallback));

      // next tab redirection
      // console.log(nextTab)
      // navigate(`/onbordingDetailsInstaform/${nextTab.replaceAll(' ', '_',)}`)
    }
  }

  // const saveCallback = (data) => {
  //     // next tab redirection
  //     if(nextTab && data?.group == '')
  //       navigate(`/onbordingDetailsInstaform/${nextTab.replaceAll(' ', '_',)}`)
  // }

  const saveCallback = (data) => {
    // next tab redirection
    if (data?.group?.group_id != "profile_preview"){
      if(nextTab){
        navigate(`/case-initiation/check-detail/${referenceNo}/11/${nextTab.replaceAll(" ", "_")}`)
      }else{
        navigate(`/case-initiation/check-detail/${referenceNo}/11/${data?.group?.group_id.replaceAll(" ", "_")}`)
      }
      // navigate(`/onbordingDetailsInstaform/${nextTab.replaceAll(" ", "_")}`);
    }else{
      if(data?.group?.group_id == "profile_preview"){
        // let reference = 17521721385945
        navigate(`/case-initiation/profile-preview/${referenceNo}`);
      }
    }
    setIsLoading(false);
  };

  const handleSubmitForPreview = () => {
    navigate(`/case-initiation/profile-preview/${referenceNo}`);
  }

 
  // const formValidation = (e) => {
  //   let err = false;

  //   // EpfData && EpfData.map((value, index) => {
  //     EpfData && Object.entries(EpfData).map(([key,valObj], idx) => {
  //       {valObj?.field_details.map((value,index)=>{
  //     if(value && value?.is_mandatory == "1" && value?.is_visible == "1"  ){
  //       if(value?.validation_type == 'custom' && value?.validation){
  //         err = matchRegex(value?.validation, val?.[value?.slug]);
  //         if(err || !val?.[value?.slug]?.[0]?.trim()){
  //           let errorTag = document.getElementById(`${value?.slug}-${value?.id}`);
  //           console.log(errorTag, 'err', value?.label)
  //           errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : 'This field is required.'
  //         }
  //       }else{
  //         if(  (!val?.[value?.slug] || val[value?.slug].trim() == '')){
  //           err = true;
  //           let errorTag = document.getElementById(`${value?.slug}-${value?.id}`);
  //           console.log(errorTag, 'err', value?.label)
  //           errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : 'This field is required.'
  //         }
  //         // if( val.input_type == 4 )
  //       }  
  //     }
  //   })}  
  //   })

  //   return err;
  // }

  const formValidation = (e) => {
    let err = false;
  
    EpfData && Object.entries(EpfData).forEach(([key, valObj]) => {
        valObj?.field_details.forEach((value) => {
            if (value && value?.is_mandatory == "1" && value?.is_visible == "1") {
                let fieldValue 
                let errorTag = document.getElementById(`${value?.slug}-${value?.id}`);
                if (value?.validation_type == 'custom' && value?.validation) {
                  fieldValue = val?.[value?.slug]
                    if (!fieldValue || !new RegExp(value?.validation).test(fieldValue)) {
                        err = true;
                        if (errorTag) {
                            if(value?.validation_msg){
                              errorTag.innerHTML = value?.validation_msg;  
                            }else if(val?.[value?.slug]?.trim() == ''){
                              errorTag.innerHTML = 'This field is required.';
                            }else{
                              errorTag.innerHTML = "Please provide a valid input." 
                            }
  
                        }
                    } else {
                        if (errorTag) {
                            errorTag.innerHTML = '';
                        }
                    }
                } else {
                  fieldValue = val?.[value?.slug]
                  console.log(fieldValue, 'errrrrr');
                    if (!fieldValue || fieldValue.trim() === '') {
                        err = true;
                        if (errorTag) {
                            // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : 'This field is required.';
                            // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : val?.[value?.slug]?.[0]?.trim() == '' ? 'This field is required.' : "Please provide a valid input." 
                            if(value?.validation_msg){
                              errorTag.innerHTML = value?.validation_msg;  
                            }else if(val?.[value?.slug]?.trim() == ''){
                              errorTag.innerHTML = 'This field is required.';
                            }else{
                              errorTag.innerHTML = "Please provide a valid input." 
                            }
  
                        }
                    } else {
                        if (errorTag) {
                            errorTag.innerHTML = '';
                        }
                    }
                }
            }
        });
    });
  
    return err;
  };

  function matchRegex(reg, value) {
    const regex = new RegExp(reg);
    return !regex.test(value);
  }


  const getMinDate = (name, date) => {
    let newDate;
  
    const getDateFromField = (section, slug) => {
      return EpfData?.[section]?.field_details.find(item => item?.slug === slug)?.value;
    };
  
    switch (name) {
      case 'validity_of_passport_to':
        newDate = val[name] || getDateFromField('Passport Details', 'validity_of_passport_from');
        break;
  
      case 'Form_11_EPF_exempted_trust_dol':
        newDate = val[name] || getDateFromField('Previous Employment Details', 'Form_11_EPF_exempted_trust_doj');
        break;
  
      case 'Form_11_EPF_unexempted_doe':
        newDate = val[name] || getDateFromField('Previous Employment Details', 'Form_11_EPF_unexempted_doj');
        break;
  
      default:
        newDate = val[name];
    }
  
    return newDate;
  };
  

  const getMaxDate = (name, date) => {
    let newDate;
  
    const getDateFromField = (section, slug) => {
      return EpfData?.[section]?.field_details.find(item => item?.slug === slug)?.value;
    };
  
    switch (name) {
      case 'validity_of_passport_from':
        newDate = val[name] || getDateFromField('Passport Details', 'validity_of_passport_to');
        break;
  
      case 'Form_11_EPF_exempted_trust_doj':
        newDate = val[name] || getDateFromField('Previous Employment Details', 'Form_11_EPF_exempted_trust_dol');
        break;
  
      case 'Form_11_EPF_unexempted_doj':
        newDate = val[name] || getDateFromField('Previous Employment Details', 'Form_11_EPF_unexempted_doe');
        break;
  
      default:
        newDate = val[name];
    }
  
    return newDate;
  };

  const handleCheckboxChange = (checked, name, id, err_id) => {
    setIsChecked(checked);
    console.log("Checkbox is now:", checked);
    setVal((prev) => ({
      ...prev,
      [name]: checked,
    }));
    let errorTag = document.getElementById(err_id);
    errorTag.innerHTML = "";
  };

  const disabledFields = [
    'Form_11_EPF_exempted_trust_eps_acc_no',
    "Form_11_EPF_unexempted_ppo_number",
    "Form_11_EPF_unexempted_scheme_certificate)number",
    "Form_11_EPF_exempted_trust_ncp_days",
    "Form_11_EPF_unexempted_ncp"
  ]
  
  console.log(val, 'payload');
  console.log(EpfData, 'payload')
  console.log(matchRegex("^d{2}-d{2}-d{4}$", "30-06-2024"), 'payload');

  return (
    <>
    <>
    {isLoading && <Loader></Loader>}
    <div className='d-block row my-3 pr-5'>
    {EpfData && Object.entries(EpfData).map(([key,value], idx) => {
      
      console.log(key, '-->' , value);
      let allSavedVal = val;
      return(
        <>
        <h4 className='pb-2 ' style={{fontWeight: 'bold', fontSize: 'larger'}}>{key}</h4>
        {key == 'Form 11' && <div className='mb-4'>
          <small>Form 11 in EPFO (Employees' Provident Fund Organization) is a self-declaration form that individuals need to fill when joining an organization covered under the EPF Scheme, 1952 and/or EPS, 1995.</small>
        </div>}
        <div className='d-flex row mt-2 mt-3'>
          {value?.field_details.map((item,index)=>{
          // textField
          if((item.input_type == 1 || item?.input_type == 2) && item?.is_visible == '1'){
          return (
            <>
              <TextField
                label={item?.label}
                name={item?.slug}
                id={item?.id}
                fieldId={`form11-${item?.id}`}
                isRequired={item?.is_mandatory}
                // errId="spouseNameError"
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value={item?.value || val[item?.slug] || ""}
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName="spouseName"
                customError={false}
                isDisabled={allDisabled || ( clientId == '88031' && disabledFields.includes(item?.slug))}
                index={index}
                collegeOther={otherInstituteObj}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                errId={`${item?.slug}-${item?.id}`}
              />
            </>
          )
          } 
          // textArea
          // if(val.input_type == 2 && val?.is_visible == '1'){
          //   return (
          //     <div className='col-lg-4 col-md-6 col-sm-12'>
          //         <textarea
          //           className="form-control"
          //           placeholder="Add Reason"
          //           style={{ resize: "none", height: 30}}
          //           value={val?.value}
          //           onChange={(e) => {}}
          //         />
          //     </div>
          //   )
          //   } 
          // dropdown
          if(item.input_type == 4 && item?.is_visible == '1' ){
            return(
              <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
                      // label="Marital Status"
                      label={item?.label}
                      labelStyle={{ color: '#6B7280' }}
                      // options={["Married", "Single", "Divorced", "Widowed", "Separated", "Other"]}
                      options={item.options}
                      onChange={handleDropdownChange}
                      errId={`${item?.slug}-${item?.id}`}
                      value={item?.slug == 'marital_status' ? maritalStatus : item?.value || ""}
                      name={item?.slug}
                      id={item?.id}
                      isRequired={item?.is_mandatory == '1' ? true : false}
                    />
                    </div>
            )
          }
          // date field
          if(item.input_type == 7 && item?.is_visible == '1' ){ 
            let minDate = null, maxDate = null;

            // Determine minDate or maxDate based on the slug value
            switch (item?.slug) {
              case 'validity_of_passport_to':
              case 'Form_11_EPF_exempted_trust_dol':
              case 'Form_11_EPF_unexempted_doe':
                maxDate = getMaxDate(val?.slug);
                break;
                
                case 'validity_of_passport_from':
                  case 'Form_11_EPF_exempted_trust_doj':
                    case 'Form_11_EPF_unexempted_doj':
                minDate = getMinDate(val?.slug);
                break;
          
              default:
                break;
            }
            return(
              <EMPDate
                      placeholder={item?.label}
                      name={item?.slug}
                      id={item?.id}
                      fieldValue={val[item?.slug] || item?.value}
                      fieldId="dateOfJoiningField"
                      paramStartDate=""
                      checkDetailsIndex={index}
                      fieldName="OnboardingFields"
                      fieldType='Onboarding'
                      // errId="dateOfJoiningError"
                      isRequired={item?.is_mandatory == '1' ? true : false}
                      saveDate={saveDateHandler}
                      isDisabled={allDisabled}
                      checkID={58} // Example checkID, adjust according to your logic
                      minDateDOL={minDate || null}
                      maxDOJDate={maxDate || null}
                      divClass="col-lg-4 col-md-6 col-sm-12"
                      placeholderStyle={{ color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis',whiteSpace: 'nowrap'}}
                      errId={`${item?.slug}-${item?.id}`}
                      customError={false}
                      EpfData={EpfData}
                      inputVal={allSavedVal}
                    />
          )}
          // Radio button
          if(item.input_type == 5 && item?.is_visible == '1' && key != 'Previous Employment Details'){
            return(
              <>
              <div className='col-12 mb-1'>
              <div className='d-flex' style={{alignItems: 'center'}}>
              <h1 className='tabsContentHead pt-2'>{item?.label}</h1>{item?.is_mandatory == 1 && <sup className="text-danger">{' '}*</sup>}
                </div>
                  <RadioButtonGroup 
                  options={Object.entries(item.options).map(([key, value]) => {return(value)}) || ["Yes", "No"]} 
                  onChange={handleRadioButtonChange} 
                  name={item?.slug}
                  id={item?.id}
                  slug={item?.slug}
                  value={item?.value}
                  isRequired={item?.is_mandatory}
                  errId={`${item?.slug}-${item?.id}`}
                  />
                  </div>
              </>
          )}

          if(item.input_type == 5 && item?.is_visible == '1' && key == 'Previous Employment Details'){
            if((item?.slug == 'earlier_member_epf_scheme' || item?.slug == 'earlier_member_ep_scheme') || (earlierEpfMember || earlierEpsMember))
            return(
              <>
              <div className='col-12 mb-0'>
                <div className='d-flex' style={{alignItems: 'center', marginBottom: 0}}>
              <h1 className='tabsContentHead'>{item?.label}</h1>{item?.is_mandatory == 1 && <sup className="text-danger">{' '}*</sup>}
                </div>
          
                  <RadioButtonGroup 
                  options={Object.entries(item.options).map(([key, value]) => {return(value)}) || ["Yes", "No"]} 
                  onChange={handleRadioButtonChange} 
                  name={item?.slug}
                  id={item?.id}
                  value={item?.value}
                  isRequired={item?.is_mandatory}
                  errId={`${item?.slug}-${item?.id}`}
                  />
                  </div>
              </>
          )}

          if (item?.input_type == 3 && item?.is_visible == "1") {
            return (
              <div
                className="col-lg-10 col-md-12 col-sm-12 mb-3"
                style={{
                  padding: 10,
                  gap: 10,
                  borderRadius: 8,
                  background: "#FFFAEB",
                }}
              >
                <Checkbox
                  label={item?.label}
                  checked={item?.value}
                  value={item?.value}
                  onChange={handleCheckboxChange}
                  name={item?.slug}
                  id={item?.id}
                  isRequired={item?.is_mandatory}
                  errId={`${item?.slug}-${item?.id}`}
                />
                <p className="err text-danger" id={`${item?.slug}-${item?.id}`}></p>
              </div>
            );
          }

        } )}
        </div>
        <div className="border-top pb-2 pt-1"></div>

        </>
      )
    })}

  
    </div>
      <div className="d-flex justify-content-start align-items-center my-5 pt-4">
        { prevTab && <button className="btn font-weight-bold btn-outline-light text-dark border mr-3" disabled={prevTab ? false : true} onClick={handleBack}>Back</button>}
        <button className="btn font-weight-bold btn-primary" onClick={saveHandler}>Save</button>
      </div>
      {showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}

    </>
    <div className='py-3 d-none'>
      <h1 className='tabsContentHead'>FORM 11 figma</h1>
      <p className='tabsContentSubHead'>
        Form 11 in EPFO (Employees' Provident Fund Organization) is a self-declaration form that individuals need to
        fill when joining an organization covered under the EPF Scheme, 1952 and/or EPS, 1995.
      </p>

      <div className="initialDetails border-bottom my-3">
        <div className="row">
          <EMPDate
            placeholder="Date of joining in current Company"
            name="dateOfJoining"
            id="dateOfJoining"
            fieldId="dateOfJoiningField"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="company_date_joining"
            fieldType='Onboarding'
            errId="dateOfJoiningError"
            isRequired={1}
            saveDate={saveDateHandler}
            isDisabled={allDisabled}
            checkID={58} // Example checkID, adjust according to your logic
            minDateDOL={null}
            maxDOJDate={null}
            divClass="col-lg-4 col-md-6 col-sm-12"
            placeholderStyle={{ color: '#6B7280' }}
          />

          <div className='col-lg-4 col-md-6 col-sm-12'>
            <QualificationDropdown
              label="Marital Status"
              labelStyle={{ color: '#6B7280' }}
              options={["Married", "Single", "Divorced", "Widowed", "Separated", "Other"]}
              onChange={handleDropdownChange}
            />
          </div>
        </div>

        <div className="row">
          <ABTextEdu
            label="Spouse Name"
            name="spouseName"
            id="spouseName"
            fieldId="spouseNameField"
            isRequired={1}
            errId="spouseNameError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="spouseName"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </div>
      </div>

      <div className="kycDetails border-bottom my-3">
        <h1 className='tabsContentHead'>KYC Details</h1>
        <div className="row">
          <ABTextEdu
            label="Bank Account Number"
            name="bankAccNo"
            id="bankAccNo"
            fieldId="bankAccNoField"
            isRequired={1}
            errId="bankAccNoError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="bankAccNo"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="IFSC Code of Branch"
            name="ifscCode"
            id="ifscCode"
            fieldId="ifscCodeField"
            isRequired={1}
            errId="ifscCodeError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="ifscCode"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Aadhaar No."
            name="aadhaarNumber"
            id="aadhaarNumber"
            fieldId="aadhaarNumberField"
            isRequired={1}
            errId="aadhaarNumberError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="aadhaarNumber"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="PAN No."
            name="panNumber"
            id="panNumber"
            fieldId="panNumberField"
            isRequired={1}
            errId="panNumberError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="panNumber"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </div>
      </div>

      <div className="international-worker border-bottom my-3">
        <h1 className='tabsContentHead'>Are you an international worker?</h1>

        <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChange} />

        {isInternationalWorker && (
          <div className='row'>
            <ABTextEdu
              label="Country of origin"
              name="countryOfOrigin"
              id="countryOfOrigin"
              fieldId="countryOfOriginField"
              isRequired={1}
              errId="countryOfOriginError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="countryOfOrigin"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
            <ABTextEdu
              label="Passport No."
              name="passportNumber"
              id="passportNumber"
              fieldId="passportNumberField"
              isRequired={1}
              errId="passportNumberError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="passportNumber"
              customError={false}
              isDisabled={allDisabled}
              index={index}
              collegeOther={otherInstituteObj}
              inputText={textHandler}
              labelStyle={{ color: '#6B7280' }}
            />
            <ABMonthYear
              placeholder="Valid from"
              name="validFrom"
              id="validFrom"
              fieldId="validFromField"
              isRequired={1}
              errId="validFromError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              paramStartDate=""
              checkDetailsIndex={index}
              fieldName="validFrom"
              isDisabled={allDisabled}
              placeholderStyle={{ color: '#6B7280' }}
            />
            <ABMonthYear
              placeholder="Valid till"
              name="validTill"
              id="validTill"
              fieldId="validTillField"
              isRequired={1}
              errId="validTillError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              paramStartDate=""
              checkDetailsIndex={index}
              fieldName="validTill"
              isDisabled={allDisabled}
              placeholderStyle={{ color: '#6B7280' }}
            />
          </div>
        )}
      </div>

      <div className="previous-employment my-3">
        <h1 className='tabsContentHead'>Previous Employment Details</h1>

        <p className='m-0 mt-2'>1. Were you earlier a member of Employees’ Provident Fund Scheme, 1952?</p>
        <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChangePFS1952} />

        <p className='m-0 mt-2'>2. Were you earlier a member of Employees Pension Scheme, 1995?</p>
        <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChangeEPS1995} />

        <p className='m-0 mt-2'>3. Is your previous organisation exempted from the EPF Scheme 1952 and/or the EPS 1995?</p>
        <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChangeEPFSorEPS} />

        <div className="row">
          <ABTextEdu
            label="Trust Name"
            name="trustName"
            id="trustName"
            fieldId="trustNameField"
            isRequired={1}
            errId="trustNameError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="trustName"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Trust Address"
            name="trustAddress"
            id="trustAddress"
            fieldId="trustAddressField"
            isRequired={1}
            errId="trustAddressError"
            caseId={caseCheckId}
            divClass="col-lg-8 col-md-12 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="trustAddress"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </div>

        <div className="row">
          <ABTextEdu
            label="UAN No."
            name="uanNumber"
            id="uanNumber"
            fieldId="uanNumberField"
            isRequired={1}
            errId="uanNumberError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="uanNumber"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Member EPS A/c Number"
            name="epsNumber"
            id="epsNumber"
            fieldId="epsNumberField"
            isRequired={1}
            errId="epsNumberError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="epsNumber"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </div>

        <div className="row">
          <ABMonthYear
            placeholder="Date of joining"
            name="dateOfJoining"
            id="dateOfJoining"
            fieldId="dateOfJoiningField"
            isRequired={1}
            errId="dateOfJoiningError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="dateOfJoining"
            isDisabled={allDisabled}
            placeholderStyle={{ color: '#6B7280' }}
          />
          <ABMonthYear
            placeholder="Date of Exit"
            name="dateOfExit"
            id="dateOfExit"
            fieldId="dateOfExitField"
            isRequired={1}
            errId="dateOfExitError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            paramStartDate=""
            checkDetailsIndex={index}
            fieldName="dateOfExit"
            isDisabled={allDisabled}
            placeholderStyle={{ color: '#6B7280' }}
          />
        </div>

        <div className="row">
          <ABTextEdu
            label="Scheme Certificate No. (if issued)"
            name="schemeCertificateNumber"
            id="schemeCertificateNumber"
            fieldId="schemeCertificateNumberField"
            isRequired={1}
            errId="schemeCertificateNumberError"
            caseId={caseCheckId}
            divClass="col-lg-8 col-md-12 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="schemeCertificateNumber"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
          <ABTextEdu
            label="Non-Contributory Period (NCP) Days"
            name="ncpDays"
            id="ncpDays"
            fieldId="ncpDaysField"
            isRequired={1}
            errId="ncpDaysError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value=""
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="ncpDays"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </div>
      </div>

      <div className="d-flex justify-content-start align-items-center my-5 pt-5">
        <button className="btn font-weight-bold btn-outline-light text-dark border mr-3">Back</button>
        <button className="btn font-weight-bold btn-primary">Save</button>
      </div>

    </div>
   </> 
  );
};

export default Form11;
